import fetch from 'isomorphic-fetch';
import logging from '@wr/logging';
import eventIds from '../../event-ids';
import config from '../../config';

export async function getProviders(requestId, paymentSessionId, sessionId) {
    const logProps = {requestId, paymentSessionId, sessionId};
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    try {
        logger.info('Retrieving TrueLayer providers', {
            eventId: eventIds['Retrieving TrueLayer providers'],
            ...logProps
        });

        const url = new URL(`/api/providers?sessionId=${paymentSessionId}`, config.trueLayerIntegrator.url);
        const providersResponse = await fetch(url.href);
        if (!providersResponse.ok) {
            throw new Error(`status ${providersResponse.status}, statusText: ${providersResponse.statusText}`);
        }
        const providers = await providersResponse.json();

        logger.info('Retrieved TrueLayer providers', {
            eventId: eventIds['Retrieved TrueLayer providers'],
            ...logProps
        });

        return providers;
    } catch (error) {
        logger.error('Error retrieving TrueLayer providers', {
            eventId: eventIds['Error retrieving TrueLayer providers'],
            ...logProps
        });
        throw error;
    }
}
